<template>
  <Layout @filter="handleFilter">

    <div class="view-list">

      <div class="view-list-inner">
        <section class="fieldset">
          <table class="table">
            <thead>
            <tr>
              <th>
                {{ $t('users.table.name') }}
              </th>
              <th style="text-align: right;padding-right: 12px;">
                {{ $t('users.table.universes') }}
              </th>
            </tr>
            </thead>
            <tbody v-if="users.length > 0">
            <tr v-for="user in users" @click="handleUserClick(user)">
              <td >
                <span class="username-cell">{{ user.name }}</span>
                <span class="username-cell badge" v-if="user.id == authUser.user.iduser">{{ $t('users.isYou') }}</span>
                <span class="ml-2 badge badge-error" v-if="user.bloque"><font-awesome-icon class="mr-1 " icon="user-times"/>{{ $t('users.accountBlocked') }}</span>
              </td>
              <td class="universes-cell">
                <RendererUniverses :roles="user.roles"></RendererUniverses>
              </td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="2" style="text-align: center">
                {{ $t('users.empty') }}
              </td>
            </tr>
            </tbody>
          </table>
        </section>
      </div>

    </div>
    <div slot="toolbarCenter">
      <Pagination ref="pagination" :store="'Users'" @change="handlePagination"></Pagination>
    </div>
    <div slot="toolbar">
      <Btn :class="'primary pull-right mobile-block'" v-can="'admin-add-users'" @click.native="handleNew">
        <font-awesome-icon icon="plus"/>
        {{ $t('users.titles.formNew') }}
      </Btn>
    </div>

  </Layout>
</template>

<script>
//import Component from 'path/to/component'

import Layout from '@l/List'

import SuperTable from '@c/ui/table/Table'
import RendererUniverses from '@c/users/RendererUniverses'
import FilterField from '@c/ui/Filter'
import Pagination from '@c/ui/Pagination'

import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  beforeCreate: function () {

  },
  beforeDestroy: function () {

  },
  beforeMount: function () {

    this.$store.commit('UI/viewTitle', this.$i18n.t('users.titles.list'))
    this.$store.commit('UI/backAction', null)
  },
  beforeUpdate: function () {

  },
  components: {
    Layout,
    SuperTable,
    RendererUniverses,
    FilterField,
    Pagination
  },
  computed: {
    ...mapGetters({
      users: 'Users/users',
      can: 'Auth/can',
      authUser: 'Auth/user'
    })
  },
  created: function () {
    this.showLoadingLight({id: 'list', show: true});
    this.fetchUsers().then(() => {
      this.showLoadingLight({id: 'list', show: false});
      this.showLoading(false);
    });

  },
  data() {
    return {}
  },
  destroyed: function () {
    this.resetConfig();
    this.resetPagination();
  },
  methods: {
    ...mapMutations({
      configFilterLike: 'Users/configFilterLike',
      configPage: 'Users/configPage',
      showLoadingLight: 'UI/showLoadingLight',
      showLoading: 'UI/showLoading',
      resetConfig: 'Users/resetConfig',
      resetPagination: 'Users/resetPagination',

    }),

    ...mapActions({
      fetchUsers: 'Users/fetchUsers',
      //can: 'Auth/can'
    }),

    handleFilter(filterValue) {
      this.configFilterLike(['name:' + filterValue]);
      this.showLoadingLight({id: 'list', show: true});
      this.fetchUsers().then(() => {
        this.showLoadingLight({id: 'list', show: false});
      });
    },
    handlePagination(page) {
      this.configPage(page);
      this.showLoadingLight({id: 'list', show: true});
      this.fetchUsers().then(() => {
        this.showLoadingLight({id: 'list', show: false});
      });
    },
    handleUserClick(user) {
      //alert(user.id);
      if (this.can('admin-read-users || admin-edit-users')) {
        this.$router.push({name: 'usersForm', params: {id: user.id}});
      }


    },
    handleNew() {
      this.$router.push({name: 'usersFormNew'});
    }
  },
  mounted: function () {

  },
  name: 'UsersList',
  props: {},
  updated: function () {

  },
  watch: {}
}
</script>

<style lang="scss">
.view-list{
  .table {
    flex-grow: 1;
    overflow: hidden;
    margin: 0;
    .username-cell {
      font-weight: $bold;
      cursor: pointer;
      vertical-align: middle;
    }
  }
}
.items-counter {
  margin: 20px 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/users/List.vue